import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
import breakpoints from 'utils/breakpoints';

const theme = createTheme({
	breakpoints: breakpoints,
});

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.Blockquote-root': {
						marginBottom: remCalc(50),

						'&.padding-normal': {
							paddingTop: remCalc(100),
							paddingBottom: remCalc(100),
						},

						'&.margin-flush': {
							marginBottom: 0,
						},
						
						'.Blockquote-quote': {
							textAlign: 'center',
							fontFamily: 'din-2014, sans-serif',
							fontWeight: 400,
							lineHeight: 1.25,
							marginBottom: remCalc(20),
							paddingLeft: remCalc(40),
							paddingRight: remCalc(20),
							[theme.breakpoints.down('sm')]: {
								fontSize: 28,
								lineHeight: 1.07,
							},
							'&:before': {
								content: 'open-quote',
								fontFamily: 'franklin-gothic-atf, sans-serif',
								fontSize: remCalc(128),
								fontWeight: 'bold',
								position: 'absolute',
								marginTop: remCalc(-50),
								marginLeft: remCalc(-100),
								[theme.breakpoints.down('sm')]: {
									fontSize: remCalc(90),
									marginLeft: remCalc(-70),
								}
							},
							'&:after': {
								content: 'close-quote',
								fontFamily: 'franklin-gothic-atf, sans-serif',
								fontSize: remCalc(128),
								fontWeight: 'bold',
								position: 'absolute',
								marginTop: remCalc(-24),
								marginLeft: remCalc(20),
								[theme.breakpoints.down('sm')]: {
									fontSize: remCalc(90),
									marginTop: remCalc(0),
									marginLeft: remCalc(45),
								}
							}
						},

						'.Blockquote-source': {
							fontStyle: 'normal',
							fontSize: 24,
							fontFamily: 'din-2014, sans-serif',
							textAlign: 'center',
							display: 'block',
							[theme.breakpoints.down('sm')]: {
								fontSize: 16,
							},
						},
					},
				},
			},
		},
	},

}

export default styles;